// Fórmulas financeiras do simulador do Método TRIA — centralizadas e testáveis.
// Todos os cálculos usam valores brutos (nunca valores arredondados da interface).

export const SIM_DEFAULTS = {
  custo: 10000,
  receitaProj: 30000,
  despesasFixas: 11000,
  receitaReal: 14000,
  despVar: 10,
};

export const calcularCenario = ({ custo, receitaProj, despesasFixas, receitaReal, despVar }) => {
  // 1. Margem bruta projetada
  const margemBruta = receitaProj - custo;
  const margemBrutaPct = receitaProj > 0 ? (margemBruta / receitaProj) * 100 : 0;

  // 2. Índice de margem de contribuição estimado (percentual − percentual)
  const imcPct = margemBrutaPct - despVar;
  const imc = imcPct / 100;

  // 3. Margem de contribuição acumulada sobre a receita realizada
  const mcAcumulada = receitaReal * imc;

  // 6. Resultado operacional estimado
  const resultado = mcAcumulada - despesasFixas;

  let status;
  if (margemBrutaPct <= 0) status = "sem_margem";
  else if (imc <= 0) status = "inviavel";
  else if (Math.abs(resultado) < 0.5) status = "equilibrio";
  else if (resultado > 0) status = "acima";
  else status = "abaixo";

  const calculavel = status === "abaixo" || status === "acima" || status === "equilibrio";

  // 4. Ponto de equilíbrio (nunca dividir por zero ou IMC negativo)
  const pe = calculavel ? despesasFixas / imc : null;
  // 5. Faturamento adicional necessário (zero quando já atingido)
  const falta = calculavel ? Math.max(0, pe - receitaReal) : null;
  const excedente = calculavel ? Math.max(0, receitaReal - pe) : null;

  return {
    custo, receitaProj, despesasFixas, receitaReal, despVar,
    margemBruta, margemBrutaPct, imcPct, imc, mcAcumulada, resultado,
    pe, falta, excedente, status,
  };
};

export const fmtFull = (v) =>
  v == null || !isFinite(v) ? "—" : (v < 0 ? "−" : "") + "R$ " + Math.round(Math.abs(v)).toLocaleString("pt-BR");

export const fmtPct = (v, d = 1) =>
  v == null || !isFinite(v) ? "—" : v.toLocaleString("pt-BR", { minimumFractionDigits: d, maximumFractionDigits: d }) + "%";

export const fmtPct2 = (v) => fmtPct(v, 2);

export const fmtImc = (v) =>
  v == null || !isFinite(v) ? "—" : v.toLocaleString("pt-BR", { minimumFractionDigits: 4, maximumFractionDigits: 4 });
